import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import "./MainContant.css";

// Components
import CountiesList from "../countiesList/CountiesList";
import Map from "../map/Map";
import Adatok from "../adatok/Adatok";
import Chart from "../chart/Chart";

// Data
import countyData from "./countymap";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  control: {
    padding: theme.spacing(2),
  },
});

const theme = createTheme({
  typography: {
    htmlFontSize: 16,
    useNextVariants: true,
    h2: {
      fontSize: "1.8em",
      fontWeight: "bold",
      textTransform: "uppercase",
    },
  },
});

const regions = {
  "==": "==",
  "01": "11",
  "02": "40",
  "03": "70",
  "04": "70",
  "05": "50",
  "06": "70",
  "07": "20",
  "08": "30",
  "09": "60",
  10: "50",
  11: "20",
  12: "50",
  13: "12",
  14: "40",
  15: "60",
  16: "60",
  17: "40",
  18: "30",
  19: "20",
  20: "30",
};

const otherRegions = {
  "==": [],
  "01": [],
  "02": ["14", "17"],
  "03": ["04", "06"],
  "04": ["03", "06"],
  "05": ["10", "12"],
  "06": ["03", "04"],
  "07": ["11", "19"],
  "08": ["18", "20"],
  "09": ["15", "16"],
  10: ["05", "12"],
  11: ["07", "19"],
  12: ["05", "10"],
  13: [],
  14: ["02", "17"],
  15: ["09", "16"],
  16: ["09", "15"],
  17: ["02", "14"],
  18: ["08", "20"],
  19: ["07", "11"],
  20: ["08", "18"],
};

class MainContant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mapAndChartHeihgt: 0,
      hoverCounty: 0,
      activeCoutie: {
        id: "==",
        name: "Ország összesen",
        path: {
          d: "",
        },
      },
      activeIndicator: {},
      activeRegions: [],
      rigthMenu: [],
      higchartsConfig: {},
      highchartsRefresh: 0,
      disableConties: true,
    };
    this.SetCounty = this.SetCounty.bind(this);
    this.SetIndicator = this.SetIndicator.bind(this);
    this.SetChart = this.SetChart.bind(this);
    this.HoverCountyEnter = this.HoverCountyEnter.bind(this);
    this.HoverCountyLeave = this.HoverCountyLeave.bind(this);
    this.createRightMenu();
  }

  componentDidMount() {
    this.setMapAndChartHight();
  }

  render() {
    const { classes } = this.props;
    const {
      activeCoutie,
      activeIndicator,
      higchartsConfig,
      rigthMenu,
      hoverCounty,
    } = this.state;
    return (
      <div className={classes.root}>
        <CssBaseline />
        <MuiThemeProvider theme={theme}>
          <Grid container spacing={3} wrap="wrap">
            <Grid item className="imgBox" xs={12}>
              <Typography variant="h1" component="h2" className="pageTitle">
                KKV | <span>Piaci információk</span>
              </Typography>
              <a
                href="https://ksh.hu"
                rel="noreferrer"
                target="_blank"
                title="KSH nyitóoldal"
              >
                <img className="kshLogo" src="full-logo-dark-grey.svg" />
              </a>
            </Grid>

            <Grid item xs={2}>
              <Paper className={"countiesList " + classes.paper}>
                <CountiesList
                  counties={countyData}
                  active={activeCoutie}
                  SetCounty={this.SetCounty}
                  hoverCounty={hoverCounty}
                  HoverCountyEnter={this.HoverCountyEnter}
                  HoverCountyLeave={this.HoverCountyLeave}
                  disableConties={this.state.disableConties}
                  activeRegions={this.state.activeRegions}
                />
              </Paper>
            </Grid>
            <Grid item xs={7}>
              {activeIndicator.menuIndex === undefined ? (
                <Paper className={"mainContant " + classes.paper}>
                  <Map
                    svgMapHeihgt={this.state.mapAndChartHeihgt}
                    counties={countyData}
                    active={activeCoutie}
                    SetCounty={this.SetCounty}
                    hoverCounty={hoverCounty}
                    HoverCountyEnter={this.HoverCountyEnter}
                    HoverCountyLeave={this.HoverCountyLeave}
                  />
                </Paper>
              ) : (
                <Paper className={"mainContant " + classes.paper}>
                  <Chart
                    higchartsConfig={higchartsConfig}
                    highchartsRefresh={this.state.highchartsRefresh}
                  />
                </Paper>
              )}
            </Grid>
            <Grid item xs={3} className="indicatorMenu">
              <Adatok
                rigthMenu={rigthMenu}
                SetIndicator={this.SetIndicator}
                active={activeIndicator}
              />
            </Grid>
          </Grid>
        </MuiThemeProvider>
      </div>
    );
  }

  createRightMenu() {
    const { kkvData } = this.props;
    const { rigthMenu } = this.state;

    let arr = rigthMenu;
    for (const key in kkvData) {
      if (Object.hasOwnProperty.call(kkvData, key)) {
        const kkvElement = kkvData[key];
        let elementIndex = arr.findIndex(
          (rightMenuElement) => rightMenuElement.name === kkvElement.category
        );

        if (elementIndex !== -1) {
          arr[elementIndex].indicators.push(kkvElement.title);
        } else {
          arr.push({
            name: kkvElement.category,
            indicators: [kkvElement.title],
          });
        }
      }
    }

    this.setState({
      rigthMenu: arr,
    });
  }

  setMapAndChartHight() {
    let mapAndChartHeight = 600;
    if (window.innerHeight) {
      mapAndChartHeight = window.innerHeight - 250;
    }

    this.setState({ mapAndChartHeihgt: mapAndChartHeight });
  }

  SetCounty(activeCoutie) {
    this.setState(
      {
        activeCoutie,
      },
      () => {
        this.SetChart();
      }
    );
  }
  SetIndicator(menuIndex, indicatorIndex) {
    let activeIndicator = {
      menuIndex,
      indicatorIndex,
    };

    this.setState(
      {
        activeIndicator,
      },
      () => {
        this.SetChart();
      }
    );
  }

  SetChart() {
    const {
      activeCoutie,
      activeIndicator,
      rigthMenu,
      mapAndChartHeihgt: mapAndChartHeight,
    } = this.state;
    const { kkvData } = this.props;

    if (
      activeIndicator.menuIndex !== undefined &&
      activeIndicator.indicatorIndex !== undefined
    ) {
      const dataIndex = kkvData.findIndex(
        (e) =>
          e.title ===
          rigthMenu[activeIndicator.menuIndex].indicators[
            activeIndicator.indicatorIndex
          ]
      );
      let chartKey = "==";
      let activeRegion = [];
      const disableLeftSideMenu = !(
        kkvData[dataIndex].kind.indexOf("regions") === -1 &&
        kkvData[dataIndex].kind.indexOf("counties") === -1
      );

      if (disableLeftSideMenu) {
        if (kkvData[dataIndex].kind.indexOf("regions") !== -1) {
          chartKey = regions[activeCoutie.id];
          activeRegion = otherRegions[activeCoutie.id];
        } else {
          chartKey = activeCoutie.id;
        }
      } else {
        this.setState({
          activeCoutie: {
            id: "==",
            name: "Ország összesen",
            path: {
              d: "",
            },
          },
        });
      }

      const chartConfig = kkvData[dataIndex].charts[chartKey];
      chartConfig.chart.height = mapAndChartHeight;
      chartConfig.chart.backgroundColor = "#ffffff";
      chartConfig.exporting = {
        sourceWidth: 1200,
        sourceHeight: 800,
        scale: 1,
        buttons: {
          contextButton: {
            menuItems: ["downloadPNG", "downloadCSV"],
          },
        },
      };

      this.setState({
        activeRegions: activeRegion,
        higchartsConfig: chartConfig,
        disableConties: disableLeftSideMenu,
        highchartsRefresh: Date.now(),
      });
    }
  }

  HoverCountyEnter(event) {
    this.setState({ hoverCounty: event.target.id });
  }

  HoverCountyLeave() {
    this.setState({ hoverCounty: 0 });
  }
}

export default withStyles(styles)(MainContant);
